// ============================================================================
// A kiosk punch's photo where punches are already listed (item "Punch kiosk
// iPad", 2026-10-22). The photo lives in the PRIVATE punch-photos store; the
// punch-photo function hands back a five-minute link only to somebody who can
// already see the punch. A thumbnail, which opens larger. No new screen.
// ============================================================================

import { useEffect, useState } from 'react';
import { punchPhotoLink } from './hooks/use-time-data';

export function PunchPhotoThumb({ photoUrl, caption }: { photoUrl: string; caption: string }) {
  const [src, setSrc] = useState<string | null>(null);
  const [failed, setFailed] = useState<string | null>(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let live = true;
    if (/^https?:\/\//.test(photoUrl)) { setSrc(photoUrl); return; }
    punchPhotoLink(photoUrl)
      .then((u) => { if (live) setSrc(u); })
      .catch((e: unknown) => { if (live) setFailed(e instanceof Error ? e.message : 'The photo could not be opened.'); });
    return () => { live = false; };
  }, [photoUrl]);

  // "Removed after 90 days" and "HR and this metro's AMs only" are said as they are (Ben, 1 Nov 2026).
  if (failed) return <span className="text-[11px] text-tcs-text-muted" title={failed}>{failed.length <= 40 ? failed : 'Photo unavailable'}</span>;
  if (!src) return <span className="inline-block h-9 w-9 animate-pulse rounded-md bg-tcs-surface" aria-label="Loading photo" />;
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} aria-label={`Open photo — ${caption}`}
        className="block h-9 w-9 overflow-hidden rounded-md border border-tcs-border">
        <img src={src} alt="" className="h-full w-full object-cover" />
      </button>
      {open && (
        <div role="dialog" aria-modal="true" aria-label={caption}
          className="fixed inset-0 z-50 flex items-center justify-center bg-tcs-scrim/60 p-4"
          onClick={() => setOpen(false)}>
          <div className="max-w-md text-center" onClick={(e) => e.stopPropagation()}>
            <img src={src} alt={caption} className="max-h-[70vh] w-auto rounded-xl" />
            <div className="mt-2 inline-block rounded-md bg-tcs-inverse px-2 py-0.5 text-sm text-tcs-inverse-ink">{caption}</div>
            <button type="button" className="mt-3 block mx-auto rounded-lg bg-tcs-surface px-4 py-2 text-sm font-semibold text-tcs-text" onClick={() => setOpen(false)}>
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
}
